/* AN: add to cart without leaving the page.
   Any form carrying data-an-cart-ajax posts to the cart's .js endpoint and
   then opens the theme's own drawer. If fetch fails, or the theme has no
   cart-drawer, the normal form post still happens, so nothing is ever lost. */
(function () {
  if (!window.fetch || !window.FormData) return;
  /* Several sections include this file; bind only once or every add happens twice. */
  if (window.__anCartAjaxBound) return;
  window.__anCartAjaxBound = true;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-an-cart-ajax]')) return;
    if (!document.querySelector('cart-drawer')) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    fetch(form.action + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        /* Refresh first, then open on the next tick. Firing both together
           loses the open, because the refresh rebuilds the drawer. */
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }, 250);
        if (btn) btn.disabled = false;
      })
      .catch(function () { form.submit(); });
  });
})();
